<!-- DEV: layout for modes.mode  -->

<template>
  <main class="grow">
    <slot />
  </main>
</template>

<script setup lang="ts">
const { modes } = useFeatureFlagsStore();
if (!modes.modeDebug) {
  navigateTo('/404');
}
</script>
